import React from 'react'

export default function HowMuchDoesItCost(props) {
  return (
    <div className="border p-10 justify-center">
      HowMuchDoesItCost
    </div>
  )
}
